<template>
  <div>
    <b-container class="mt-15 container card_container">
      <h3 class="mb-5 titolo"><i class="fas fa-user"></i> Profilo Utente</h3>
      <b-row>
        <b-col cols="6" xs="12" sm="12" md="12" lg="4">
          <strong>Nome</strong>
          <br />
          <span>{{ assistito.nome }}</span>
        </b-col>
        <b-col cols="6" xs="12" sm="12" md="12" lg="4">
          <strong>Cognome</strong>
          <br />
          <span>{{ assistito.cognome }}</span>
        </b-col>
        <b-col cols="6" xs="12" sm="12" md="12" lg="4">
          <strong>Codice Fiscale</strong>
          <br />
          <span>{{ assistito.codiceFiscale }}</span>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col cols="6" xs="12" sm="12" md="12" lg="6">
          <strong>Luogo di Nascita</strong>
          <br />
          <span>{{ assistito.luogoDiNascita }}</span>
        </b-col>
        <b-col cols="6" xs="12" sm="12" md="12" lg="6">
          <strong>Data di Nascita</strong>
          <br />
          <span>{{ assistito.dataNascita }}</span>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col cols="6" xs="12" sm="12" md="12" lg="4">
          <strong>Sesso</strong>
          <br />
          <span>{{ assistito.sesso }}</span>
        </b-col>
        <b-col cols="6" xs="12" sm="12" md="12" lg="4">
          <strong>Stato Civile</strong>
          <br />
          <span>{{ assistito.statoCivile }}</span>
        </b-col>
        <b-col cols="6" xs="12" sm="12" md="12" lg="4">
          <strong>Provincia di Residenza</strong>
          <br />
          <span> {{ assistito.provinciaResidenza }}</span>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col cols="6" xs="12" sm="12" md="12" lg="4">
          <strong>Comune di Residenza</strong>
          <br />
          <span>{{ assistito.comuneResidenza }}</span>
        </b-col>
        <b-col cols="6" xs="12" sm="12" md="12" lg="4">
          <strong>Indirizzo di Residenza</strong>
          <br />
          <span>{{ assistito.indirizzoResidenza }}</span>
        </b-col>
        <b-col cols="6" xs="12" sm="12" md="12" lg="4">
          <strong>Cittadinanza</strong>
          <br />
          <span>{{ assistito.cittadinanza }}</span>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col cols="6" xs="12" sm="12" md="12" lg="4">
          <strong>Cellulare</strong>
          <br />
          <span>{{ numeroCellulareAssente }}</span>
        </b-col>
        <b-col cols="6" xs="12" sm="12" md="12" lg="4">
          <strong>Telefono Fisso</strong>
          <br />
          <span>{{ numeroFissoAssente }}</span>
        </b-col>
        <b-col cols="6" xs="12" sm="12" md="12" lg="4">
          <strong>Email</strong>
          <br />
          <span>{{ assistito.email }}</span>
        </b-col>
      </b-row>
      <br />
      <b-row>
        <div class="footer d-flex justify-content-end">
          <b-button variant="outline-primary" class="ml-2 btn-outline" @click="onModifica"> <i class="fas fa-pen"></i> Modifica </b-button>
          <b-button variant="danger" class="ml-2 text-primary-w" @click="onElimina"> <i class="fas fa-trash"></i> Elimina </b-button>
        </div>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import AuthService from "@/services/authService";
import getVocabolario from "@/utilities/utilityCercaVocabolario";
export default {
  components: {},
  data() {
    return {
      pathResorceInfoUtente: "/api/v2.0/appecupt/auth/prelevaAnagraficaUtente",
      pathResourceEliminaContatto: "/api/v2.0/appecupt/auth/eliminaaccount",
      assistito: {},
      tokenLogin: null,
      isLoading: false,
    };
  },
  computed: {
    numeroCellulareAssente() {
      return this.assistito.numeroCellulare === "" || this.assistito.numeroCellulare === null ? "NUMERO CELLULARE ASSENTE" : this.assistito.numeroCellulare;
    },
    numeroFissoAssente() {
      return this.assistito.numeroFisso === "" || this.assistito.numeroFisso === null ? "NUMERO TELEFONO FISSO ASSENTE" : this.assistito.numeroFisso;
    },
  },
  mounted: function () {
    let me = this;
    me.tokenLogin = sessionStorage.getItem("loginData");
    me.loadInfoUtente();
  },
  methods: {
    async loadInfoUtente() {
      let me = this;
      try {
        const responseInfoUtente = await AuthService.anagraficaUtente(me.tokenLogin);
        me.assistito = responseInfoUtente.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    onElimina() {
      let me = this;
      me.isLoading = true;
        let msg = getVocabolario("eliminaUtenza")
        if(!msg)
            msg = "Sei sicuro di voler eliminare il profilo Utente?"
      this.$bvModal
        .msgBoxConfirm(msg, {
          title: "Conferma Eliminazione",
          footerClass: "p-2",
          centered: true,
          cancelTitle: "Chiudi",
          okTitle: "Conferma",
        })
        .then(async (response) => {
          if (response) {
            try {
              const responseEliminaAccount = await AuthService.eliminaAccount();
              if (responseEliminaAccount.data.stato === 200) {
                me.isLoading = false;
                me.$bvModal
                  .msgBoxOk(responseEliminaAccount.data.data, {
                    title: "Esito Eliminazione",
                    size: "md",
                    okVariant: "primary",
                    headerClass: "header-success",
                    footerClass: "p-2 border-top-0",
                    centered: true,
                  })
                  .then(() => {
                    me.$router.replace("/").catch((err) => {
                      console.log(err);
                    });
                  })
                  .catch(() => {});
              } else {
                me.$bvModal
                  .msgBoxOk(responseEliminaAccount.data.errore, {
                    title: "Errore Eliminazione",
                    size: "md",
                    okVariant: "outline-danger",
                    headerClass: "vv-msg-header-danger",
                    footerClass: "p-2 border-top-0",
                    centered: true,
                  })
                  .then(() => {})
                  .catch(() => {});
              }
            } catch (e) {
              me.isLoading = false;
              me.$bvModal
                .msgBoxOk(e, {
                  title: "Errore",
                  size: "md",
                  okVariant: "outline-danger",
                  headerClass: "vv-msg-header-danger",
                  footerClass: "p-2 border-top-0",
                  centered: true,
                })
                .then(() => {
                  me.isLoading = false;
                })
                .catch(() => {
                  me.isLoading = false;
                });
            }
          }
        })
        .catch((error) => {
          me.isLoading = false;
          me.$bvModal
            .msgBoxOk(error, {
              title: "Errore",
              size: "md",
              okVariant: "outline-danger",
              headerClass: "vv-msg-header-danger",
              footerClass: "p-2 border-top-0",
              centered: true,
            })
            .then(() => {
              me.isLoading = false;
            })
            .catch(() => {
              me.isLoading = false;
            });
        });
    },
    onModifica() {
      let me = this;
      me.$emit("modificaUtente", me.assistito);
    },
  },
};
</script>
